import { render, staticRenderFns } from "./slider-video-item.vue?vue&type=template&id=9f9d16a4&scoped=true&"
import script from "./slider-video-item.vue?vue&type=script&lang=js&"
export * from "./slider-video-item.vue?vue&type=script&lang=js&"
import style0 from "./slider-video-item.vue?vue&type=style&index=0&id=9f9d16a4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9d16a4",
  null
  
)

export default component.exports